import { render, staticRenderFns } from "./staffInfo.vue?vue&type=template&id=f53cc9ac&scoped=true&"
import script from "./staffInfo.vue?vue&type=script&lang=js&"
export * from "./staffInfo.vue?vue&type=script&lang=js&"
import style0 from "./staffInfo.vue?vue&type=style&index=0&id=f53cc9ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53cc9ac",
  null
  
)

export default component.exports